import {
  FETCH_USER,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILED,
  USER_SIGN_IN,
  USER_SIGN_IN_FAILED,
  USER_SIGN_OUT,
  CLEAR_LOGIN_ERROR,
  REQUEST_OTP_SUCCESS,
  UPDATE_USER_WALLET_HISTORY,
  SEND_RESET_EMAIL,
  SEND_RESET_EMAIL_FAILED
} from "../store/types";

import store from '../store/store';
import { getSupabase, createIsolatedSupabaseClient } from '../config/configureSupabase';
import { uploadMedia } from '../other/supabaseStorage';

let authStateListenerUnsub = null;

const formatProfile = (user, profile) => {
  return {
    ...(profile || {}),
    id: user?.id || profile?.id,
    uid: user?.id || profile?.id,
    email: user?.email || profile?.email,
    firstName: profile?.first_name || user?.user_metadata?.first_name || 'Usuário',
    lastName: profile?.last_name || user?.user_metadata?.last_name || '',
    first_name: profile?.first_name || user?.user_metadata?.first_name || 'Usuário',
    last_name: profile?.last_name || user?.user_metadata?.last_name || '',
    mobile: profile?.mobile || user?.user_metadata?.mobile || '',
    usertype: profile?.usertype || user?.user_metadata?.usertype || 'driver',
    tenant_id: profile?.tenant_id || user?.user_metadata?.tenant_id,
    tenantId: profile?.tenant_id || user?.user_metadata?.tenant_id,
    driverActiveStatus: profile?.driver_active_status ?? profile?.driverActiveStatus ?? false,
    driver_active_status: profile?.driver_active_status ?? profile?.driverActiveStatus ?? false,
    approved: profile?.approved ?? true,
    is_superadmin: profile?.is_superadmin ?? false,
    profile_image: profile?.profile_image || ''
  };
};

export const fetchUser = () => async (dispatch) => {
  const supabase = getSupabase();

  if (supabase) {
    dispatch({
      type: FETCH_USER,
      payload: null
    });

    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.user) {
        const { data: profile } = await supabase
          .from('profiles')
          .select('*')
          .eq('id', session.user.id)
          .maybeSingle();

        const userProfile = formatProfile(session.user, profile);
        dispatch({
          type: FETCH_USER_SUCCESS,
          payload: userProfile
        });
      } else {
        dispatch({
          type: FETCH_USER_FAILED,
          payload: { code: 'auth_error', message: 'not_logged_in' }
        });
      }

      if (!authStateListenerUnsub) {
        const { data: { subscription } } = supabase.auth.onAuthStateChange(async (event, session) => {
          if (event === 'SIGNED_IN' && session?.user) {
            const { data: profile } = await supabase
              .from('profiles')
              .select('*')
              .eq('id', session.user.id)
              .maybeSingle();

            const userProfile = formatProfile(session.user, profile);
            dispatch({
              type: FETCH_USER_SUCCESS,
              payload: userProfile
            });
          } else if (event === 'SIGNED_OUT') {
            dispatch({
              type: USER_SIGN_OUT,
              payload: null
            });
          }
        });
        authStateListenerUnsub = subscription;
      }
      return;
    } catch (e) {
      console.warn('[authactions] Supabase fetchUser error:', e);
      dispatch({
        type: FETCH_USER_FAILED,
        payload: { code: 'auth_error', message: e.message }
      });
    }
  } else {
    dispatch({
      type: FETCH_USER_FAILED,
      payload: { code: 'auth_error', message: 'no_client' }
    });
  }
};

export const validateReferer = async (referralId) => {
  return { valid: true };
};

export const getAuthRedirectUrl = (customRedirect) => {
  if (customRedirect && typeof customRedirect === 'string') {
    return customRedirect;
  }
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    return `${window.location.origin}/`;
  }
  const settings = store.getState()?.settingsdata?.settings;
  if (settings?.CompanyWebsite && typeof settings.CompanyWebsite === 'string' && settings.CompanyWebsite.startsWith('http')) {
    return settings.CompanyWebsite.endsWith('/') ? settings.CompanyWebsite : `${settings.CompanyWebsite}/`;
  }
  return 'https://alphagiro-fleet-web.pages.dev/';
};

export const checkUserExists = async (data) => {
  const supabase = getSupabase();
  if (supabase) {
    try {
      if (data.email) {
        const { data: rows } = await supabase
          .from('profiles')
          .select('id')
          .eq('email', data.email.trim())
          .limit(1);
        if (rows && rows.length > 0) return { users: rows, error: 'email_exists' };
      }
      if (data.mobile) {
        const { data: rows } = await supabase
          .from('profiles')
          .select('id')
          .eq('mobile', data.mobile.trim())
          .limit(1);
        if (rows && rows.length > 0) return { users: rows, error: 'phone_exists' };
      }
    } catch (e) {
      console.warn('[authactions] checkUserExists error:', e);
    }
  }
  return { users: [], error: false };
};

export const mainSignUp = async (regData) => {
  const supabase = getSupabase();
  if (!supabase) {
    return { error: 'Serviço de autenticação não inicializado.' };
  }

  try {
    const isolatedClient = createIsolatedSupabaseClient();
    const client = isolatedClient || supabase;

    const email = regData.email ? regData.email.trim() : '';
    const metadata = {
      first_name: regData.firstName || regData.first_name || 'Motorista',
      last_name: regData.lastName || regData.last_name || '',
      mobile: regData.mobile || '',
      usertype: regData.usertype || 'driver',
      referral_id: regData.referralId || null,
      signup_via_referral: regData.signupViaReferral || null
    };

    const redirectUrl = getAuthRedirectUrl();

    const { data: authData, error: authError } = await client.auth.signUp({
      email,
      password: regData.password,
      options: {
        data: metadata,
        emailRedirectTo: redirectUrl
      }
    });

    if (authError) {
      console.error('[authactions] mainSignUp error:', authError);
      return { error: authError.message };
    }

    if (authData?.user && Array.isArray(authData.user.identities) && authData.user.identities.length === 0) {
      return { error: 'Este e-mail já está cadastrado no sistema.' };
    }

    const createdUserId = authData?.user?.id;
    if (!createdUserId) {
      return { error: 'Falha ao registrar usuário.' };
    }

    return {
      uid: createdUserId,
      user: authData.user,
      requiresConfirmation: !authData.session
    };
  } catch (err) {
    console.error('[authactions] mainSignUp exception:', err);
    return { error: err.message || 'Erro inesperado no cadastro.' };
  }
};

export const requestPhoneOtpDevice = (phoneNumber, appVerifier) => async (dispatch) => {
  dispatch({
    type: REQUEST_OTP_SUCCESS,
    payload: null
  });
};

export const mobileSignIn = (verId, code) => async (dispatch) => {
  dispatch({
    type: USER_SIGN_IN_FAILED,
    payload: { code: 'auth_error', message: 'Utilize login com e-mail e senha.' }
  });
};

export const emailSignUp = (user) => async (dispatch) => {
  dispatch({
    type: USER_SIGN_IN,
    payload: null
  });

  const supabase = getSupabase();
  if (!supabase) return;

  try {
    const redirectUrl = getAuthRedirectUrl();
    const { data, error } = await supabase.auth.signUp({
      email: user.email.trim(),
      password: user.password,
      options: {
        data: {
          first_name: user.firstName,
          last_name: user.lastName,
          mobile: user.mobile,
          usertype: user.usertype || 'driver'
        },
        emailRedirectTo: redirectUrl
      }
    });

    if (error) {
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: { code: 'auth_error', message: error.message }
      });
      return;
    }

    if (data?.user) {
      await supabase.from('profiles').upsert({
        id: data.user.id,
        email: user.email.trim(),
        first_name: user.firstName,
        last_name: user.lastName,
        mobile: user.mobile,
        usertype: user.usertype || 'driver'
      });

      const profile = formatProfile(data.user, {
        id: data.user.id,
        email: user.email.trim(),
        first_name: user.firstName,
        last_name: user.lastName,
        mobile: user.mobile,
        usertype: user.usertype || 'driver'
      });

      dispatch({
        type: FETCH_USER_SUCCESS,
        payload: profile
      });
    }
  } catch (err) {
    dispatch({
      type: USER_SIGN_IN_FAILED,
      payload: { code: 'auth_error', message: err.message }
    });
  }
};

export const googleLogin = (credential) => async (dispatch) => {};
export const appleSignIn = (credential) => async (dispatch) => {};
export const verifyEmailOtp = (email, otp) => async (dispatch) => {};

export const signOff = () => async (dispatch) => {
  const supabase = getSupabase();
  if (supabase) {
    await supabase.auth.signOut();
  }
  dispatch({
    type: USER_SIGN_OUT,
    payload: null
  });
};

export const updateProfile = (updateData) => async (dispatch) => {
  const supabase = getSupabase();
  if (supabase) {
    const { data: { session } } = await supabase.auth.getSession();
    const uid = session?.user?.id || store.getState().auth?.profile?.id || store.getState().auth?.profile?.uid;
    if (uid) {
      const cleanData = { ...updateData };
      delete cleanData.uid;
      delete cleanData.id;
      if (cleanData.driverActiveStatus !== undefined) {
        if (cleanData.driver_active_status === undefined) cleanData.driver_active_status = cleanData.driverActiveStatus;
        delete cleanData.driverActiveStatus;
      }
      const { error } = await supabase.from('profiles').update(cleanData).eq('id', uid);
      if (error) {
        console.warn('[authactions] updateProfile error:', error.message);
        return { error: error.message };
      }
      const current = store.getState().auth?.profile || {};
      const patch = { ...cleanData };
      if (patch.driver_active_status !== undefined) patch.driverActiveStatus = patch.driver_active_status;
      if (patch.driverActiveStatus !== undefined && patch.driver_active_status === undefined) patch.driver_active_status = patch.driverActiveStatus;
      dispatch({
        type: FETCH_USER_SUCCESS,
        payload: { ...current, ...patch }
      });
    }
  }
};

export const updateProfileWithEmail = (profileData) => async (dispatch) => {
  const supabase = getSupabase();
  if (supabase) {
    try {
      const email = profileData.email ? profileData.email.trim() : null;
      if (email) {
        await supabase.auth.updateUser({ email });
      }
      await updateProfile(profileData)(dispatch);
    } catch (e) {
      console.warn('[authactions] updateProfileWithEmail error:', e);
    }
  }
};

export const updateProfileImage = (imageBlob) => async (dispatch) => {
  const profile = store.getState().auth?.profile;
  const uid = profile?.uid || profile?.id;
  if (!uid || !imageBlob) return;
  const publicUrl = await uploadMedia('media', `profiles/${uid}.jpg`, imageBlob, 'image/jpeg');
  if (publicUrl) {
    await updateProfile({ profile_image: publicUrl })(dispatch);
  }
};

export const updateWebProfileImage = async (imageBlob) => {
  const profile = store.getState().auth?.profile;
  const uid = profile?.uid || profile?.id;
  if (!uid || !imageBlob) return null;
  return await uploadMedia('media', `profiles/${uid}.jpg`, imageBlob, 'image/jpeg');
};

export const updatePushToken = (token, platform) => async (dispatch) => {
  const supabase = getSupabase();
  const profile = store.getState().auth?.profile;
  const uid = profile?.uid || profile?.id;
  if (supabase && uid && token) {
    try {
      await supabase.from('profiles').update({
        push_token: token,
        user_platform: platform || 'mobile'
      }).eq('id', uid);
    } catch (e) {}
  }
};

export const clearLoginError = () => (dispatch) => {
  dispatch({
    type: CLEAR_LOGIN_ERROR,
    payload: null
  });
};

export const fetchWalletHistory = () => (dispatch) => {
  dispatch({
    type: UPDATE_USER_WALLET_HISTORY,
    payload: []
  });
};

export const sendResetMail = (email) => async (dispatch) => {
  const supabase = getSupabase();
  dispatch({
    type: SEND_RESET_EMAIL,
    payload: email
  });

  if (supabase) {
    const redirectUrl = getAuthRedirectUrl();
    const { error } = await supabase.auth.resetPasswordForEmail(email.trim(), {
      redirectTo: redirectUrl
    });
    if (error) {
      dispatch({
        type: SEND_RESET_EMAIL_FAILED,
        payload: { code: 'auth_error', message: error.message }
      });
    }
  }
};

export const verifyEmailPassword = (email, pass) => async (dispatch) => {
  dispatch({
    type: USER_SIGN_IN,
    payload: null
  });

  const supabase = getSupabase();
  if (!supabase) {
    console.error('[authactions] Supabase client is not available in verifyEmailPassword');
    dispatch({
      type: USER_SIGN_IN_FAILED,
      payload: { code: 'no_client', message: 'Serviço de autenticação não inicializado.' }
    });
    return;
  }

  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email: (email || '').trim(),
      password: pass
    });

    if (error) {
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: { code: error.status || 'auth_error', message: error.message }
      });
      return;
    }

    if (data?.user) {
      const { data: profile } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', data.user.id)
        .maybeSingle();

      const userProfile = formatProfile(data.user, profile);
      dispatch({
        type: FETCH_USER_SUCCESS,
        payload: userProfile
      });
    } else {
      dispatch({
        type: USER_SIGN_IN_FAILED,
        payload: { code: 'user_not_found', message: 'Usuário não encontrado.' }
      });
    }
  } catch (err) {
    console.error('[authactions] verifyEmailPassword exception:', err);
    dispatch({
      type: USER_SIGN_IN_FAILED,
      payload: { code: 'auth_exception', message: err.message || 'Falha ao autenticar.' }
    });
  }
};
